import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createSlots as _createSlots, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-eb843b3a")

_pushScopeId("data-v-eb843b3a")
const _hoisted_1 = { class: "justify-start" }
const _hoisted_2 = { class: "m-left-sm" }
const _hoisted_3 = { class: "m-left-sm" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 1,
  class: "send-status-text"
}
const _hoisted_7 = {
  key: 2,
  class: "send-status-text"
}
const _hoisted_8 = {
  key: 3,
  class: "send-status-text"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_custom_form_item = _resolveComponent("custom-form-item")
  const _component_el_input_number = _resolveComponent("el-input-number")
  const _component_custom_form = _resolveComponent("custom-form")
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_dialog_shell = _resolveComponent("dialog-shell")

  return (_openBlock(), _createBlock(_component_dialog_shell, {
    title: _ctx.$wordList.SentClickPayManually,
    onClose: _ctx.close,
    footerType: "customize"
  }, _createSlots({
    default: _withId(() => [
      (_ctx.sendStatus === 1 && !_ctx.isSuccessDialog)
        ? (_openBlock(), _createBlock(_component_custom_form, {
            key: 0,
            ref: "formRef",
            model: _ctx.formData
          }, {
            default: _withId(() => [
              _createVNode(_component_custom_form_item, {
                label: _ctx.$wordList.StartDate
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: _ctx.formData.EffectDate,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.EffectDate = $event)),
                    type: "date",
                    "disabled-date": _ctx.startDateOption,
                    clearable: false
                  }, null, 8, ["modelValue", "disabled-date"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_custom_form_item, {
                label: _ctx.$wordList.ProperAllTextExportLogDuration
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_1, [
                    _createVNode(_component_el_input_number, {
                      modelValue: _ctx.formData.RenewMonth,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.RenewMonth = $event)),
                      min: 0,
                      max: 12
                    }, null, 8, ["modelValue"]),
                    _createVNode("p", {
                      class: "m-left-sm",
                      innerHTML: _ctx.$wordList.DurationMonthAndDays.format(`<b>${_ctx.remainingDays}</b>`)
                    }, null, 8, ["innerHTML"])
                  ])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_custom_form_item, {
                label: _ctx.$wordList.TmpKeyListTanleExpirationTime
              }, {
                default: _withId(() => [
                  _createVNode("span", _hoisted_2, _toDisplayString(_ctx.expirationDate), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_custom_form_item, {
                label: _ctx.$wordList.CommunalFee
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_3, [
                    _createVNode("span", null, _toDisplayString(`${_ctx.formData.RenewMonth} * ${_ctx.communalFee}`), 1),
                    (_ctx.currentRemainDate > 0 )
                      ? (_openBlock(), _createBlock("span", _hoisted_4, " + " + _toDisplayString(`${_ctx.currentRemainDate} * (${_ctx.communalFee}/${_ctx.getDaysOfMonth(_ctx.formData.EffectDate)})`), 1))
                      : _createCommentVNode("", true),
                    (_ctx.dueDate !== 1 && _ctx.formData.EffectDate.getDate() > _ctx.dueDate)
                      ? (_openBlock(), _createBlock("span", _hoisted_5, " + " + _toDisplayString(`${_ctx.dueDate-1} * (${_ctx.communalFee}/${_ctx.getDaysOfMonth(_ctx.nextMonthDueDate)})`), 1))
                      : _createCommentVNode("", true),
                    _createTextVNode(" = ₼ " + _toDisplayString(_ctx.allCommunalFee), 1)
                  ])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }, 8, ["model"]))
        : _createCommentVNode("", true),
      (_ctx.isSuccessDialog)
        ? (_openBlock(), _createBlock("div", _hoisted_6, _toDisplayString(_ctx.$wordList.ClickpaySentSuccessfully), 1))
        : _createCommentVNode("", true),
      (_ctx.sendStatus === 2)
        ? (_openBlock(), _createBlock("div", _hoisted_7, _toDisplayString(_ctx.$wordList.PleaseSetTheAreaFirst), 1))
        : _createCommentVNode("", true),
      (_ctx.sendStatus === 3)
        ? (_openBlock(), _createBlock("div", _hoisted_8, _toDisplayString(_ctx.$wordList.SendClickPayHasBeenPaid), 1))
        : _createCommentVNode("", true)
    ]),
    _: 2
  }, [
    (_ctx.sendStatus === 1 && !_ctx.isSuccessDialog)
      ? {
          name: "footer",
          fn: _withId(() => [
            _createVNode(_component_cus_button, {
              class: "m-right-sm",
              onClick: _ctx.close
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootCancel), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_cus_button, {
              type: "blue",
              onClick: _ctx.sendClickPaysApi
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextSend), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        }
      : undefined
  ]), 1032, ["title", "onClose"]))
})